// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useAuthN } from 'hooks/auth/subscriptions';

function AuthNWrapper(Component) {
  const Wrapper = ({ authTypes, ...rest }) => {
    const authenticated = useAuthN(authTypes);
    return (
      <Component
        authenticated={authenticated}
        authTypes={authTypes}
        {...rest}
      />
    );
  };
  Wrapper.propTypes = {
    authTypes: PropTypes.arrayOf(PropTypes.string),
  };
  Wrapper.defaultProps = {
    authTypes: [],
  };
  return Wrapper;
}

export default AuthNWrapper;
